import axios from "axios"

export default {
    namespaced: true,

    state: {
        pages: []
    },
    mutations: {
        setPages(state, array){
            state.pages = array
        }
    },
    actions: {
        fetchData(context, payload){
            let lang = payload.lang
            axios({
                method: "post",
                data: {
                    query: `
                        query($lang:[String]){
                            pages: entries(section: "pages", site: $lang){
                                id,
                                slug,
                                title,
                                visibility
                            }
                        }`,
                    variables: {
                        lang
                    }
                }
            }).then(function(res){
                context.commit('setPages', res.data.data.pages)
            })
        }
    },
    getters: {}
}
